import { virtualTouchable as virtualTouchable$1, yAxisOnly } from "./virtualTouchable.css.mjs";
function virtualTouchable({ xAxis } = { xAxis: true }) {
  return !xAxis ? [virtualTouchable$1, yAxisOnly] : virtualTouchable$1;
}
export {
  virtualTouchable
};
